import { Platform } from 'react-native';
import axios from 'axios';
import Constants from 'expo-constants';

if (Platform.OS.equals('web') && (__DEV__ || Constants.expoConfig.extra?.enablePerformanceLogging === 'true')){
    axios.interceptors.request.use(config => {
        config.requestStartTime = performance.now();
        return config;
    });

    axios.interceptors.response.use(response => {
        const duration = ((performance.now() - response.config.requestStartTime) / 1000);
        console.log(`Request [${response.config.url}] took ${duration}s`);
        return response;
    });
}

const useAxios = () => {
    const get = async endpoint => {
        const response = await axios.get(Constants.expoConfig.extra?.baseUrl + endpoint);

        if (response?.data) {
            return response.data;
        }
    };

    const getFromApiServer = async endpoint => {
        const response = await axios.get(Constants.expoConfig.extra?.apiUrl + endpoint);

        if (response?.data) {
            return response.data;
        }
    };

    const getGeneric = async (endpoint, headers) => {
        const response = await axios.get(endpoint, { headers });

        if (response?.data) {
            return response.data;
        }
    };

    const post = async (endpoint, body, contentType = 'multipart/form-data', headers) => {
        const response = await axios.post(Constants.expoConfig.extra?.baseUrl + endpoint, body, {
            headers: {
                'Content-Type': contentType,
                ...headers
            }
        });

        if (response?.data) {
            return response.data;
        }
    };

    const postGeneric = async (endpoint, body, contentType = 'application/json', headers) => {
        let data = body;

        if (body && contentType?.equals('multipart/form-data')) {
            data = new FormData();
            Object.keys(body).forEach(key => data.append(key, body[key]));
        }

        try {
            const response = await axios.post(endpoint, body, {
                headers: {
                    'Content-Type': contentType,
                    ...headers
                }
            });

            if (response?.data) {
                return response.data;
            }
        } catch (e) {}
    };

    const postToApiServer = async (endpoint, body, contentType = 'application/json', headers) => {
        let data = body;

        if (body && contentType?.equals('multipart/form-data')) {
            data = new FormData();
            Object.keys(body).forEach(key => data.append(key, body[key]));
        }

        try {
            const response = await axios.post(Constants.expoConfig.extra?.apiUrl + endpoint, body, {
                headers: {
                    'Content-Type': contentType,
                    ...headers
                }
            });

            if (response?.data) {
                return response.data;
            }
        } catch (e) {}
    };

    return {
        get,
        getFromApiServer,
        getGeneric,
        post,
        postGeneric,
        postToApiServer
    };
};

export default useAxios;
